import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import GiftCardBuyRecipientEvoucher from './GiftCardBuyRecipientEvoucher';
import GiftCardBuyRecipientPostal from './GiftCardBuyRecipientPostal';
import GiftsHeader from './GiftsHeader';

//TODO: Remove this when removing GIFT_MAX_CHARS -> UD-615_Gifts-max-characters
import GiftCardBuyRecipientPostalOld from './GiftCardBuyRecipientPostalOld';

//TODO: Remove this when removing GIFT_MAX_CHARS -> UD-615_Gifts-max-characters
import ClientWithSplitTreatments from 'spa/Components/SplitIo/ClientWithSplitTreatments'; // eslint-disable-line
import SPLIT_TREATMENTS from 'spa/state/SplitTreatmentIdMap'; // eslint-disable-line

const GiftCardBuyStepTwo = ({
  currentStep,
  deliveryOption,
  handleRecipientChange,
  recipient,
  sendDateInvalid,
  setSendDateInvalid,
  isReady,
  treatments,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <GiftsHeader currentStep={currentStep} />
      {deliveryOption === 'e-voucher' && <GiftCardBuyRecipientEvoucher recipient={recipient} handleRecipientChange={handleRecipientChange} sendDateInvalid={sendDateInvalid} setSendDateInvalid={setSendDateInvalid} />}
      {(isReady || (process.env && process.env.NODE_ENV === 'test')) ? (
        <React.Fragment>
          {(treatments[SPLIT_TREATMENTS.GIFT_MAX_CHARS].treatment === 'on' || (process.env && process.env.NODE_ENV === 'test')) ? (
            <React.Fragment>
              {deliveryOption === 'postal-voucher' && <GiftCardBuyRecipientPostal recipient={recipient} handleRecipientChange={handleRecipientChange} />}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {deliveryOption === 'postal-voucher' && <GiftCardBuyRecipientPostalOld recipient={recipient} handleRecipientChange={handleRecipientChange} />}
            </React.Fragment>
          )}
        </React.Fragment>
      ) : null}
    </div>
  );
};

GiftCardBuyStepTwo.propTypes = {
  currentStep: PropTypes.number.isRequired,
  deliveryOption: PropTypes.string.isRequired,
  handleRecipientChange: PropTypes.func.isRequired,
  recipient: PropTypes.object.isRequired,
  sendDateInvalid: PropTypes.bool,
  setSendDateInvalid: PropTypes.func.isRequired,
  isReady: PropTypes.bool.isRequired,
  treatments: PropTypes.object.isRequired,
};

export default ClientWithSplitTreatments([SPLIT_TREATMENTS.GIFT_MAX_CHARS])(GiftCardBuyStepTwo);



// WEBPACK FOOTER //
// ./spa/Pages/Gifts/GiftCardBuyStepTwo.jsx